﻿import type { StatsGridComponent } from "../../types";

/** Statistical KPI grid renderer on blue background. */
export function StatsGridRenderer({ component }: { component: StatsGridComponent }) {
  const { items } = component.content;
  return (
    <section>
      <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3">
        {items.map((m, i) => (
          <div key={i} className="rounded-md bg-[#005CA9] text-white">
            <div className="flex h-36 md:h-40 flex-col items-center justify-center p-4 text-center">
              <div className="text-xs xl:text-sm md:text-sm opacity-90">{m.title}</div>
              <div className="mt-1 text-3xl md:text-4xl font-extrabold tracking-tight">{m.value}</div>
              <div className="mt-1 text-[11px] md:text-xs opacity-80">{m.meta}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}


